import axios from 'axios';
import StaticVar from '../Config/StaticVar';

const axiosInstance = axios.create({
  baseURL: StaticVar.URL_API, // Ganti sesuai base URL API kamu
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// === [TAMBAHKAN DI SINI] ===
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Interceptor untuk menangani response error
axiosInstance.interceptors.response.use(
  response => {
    // Hanya return jika status 200
    if (response.status === 200) {
      return response;
    } else {
      // Redirect to login if 401 Unauthorized
      console.log('disini')
      // if (response.status === 401) {
      //   window.location.href = '/app/login'; // Ganti dengan route login Anda
      // }

      return Promise.reject(new Error(`Unexpected response status: ${response.status}`));
    }
  },
  error => {
    // Jika error dari server (non-200), atau tidak ada respons sama sekali
    console.log('err disini')
    // window.location.href = '/app/login';
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data);
      return Promise.reject(error.response.data); // atau error.response jika butuh lengkap
    } else if (error.request) {
      console.error('No response from server:', error.request);
      return Promise.reject({ message: 'No response from server' });
    } else {
      console.error('Request setup error:', error.message);
      return Promise.reject({ message: error.message });
    }
  }
);

const getAssesment = async (event_id, evaluator_id, group_id) => {
  const response = await axiosInstance.get(`/assesment?event_id=${event_id}&evaluator_id=${evaluator_id}&group_id=${group_id}`);
  console.log('response getAssesment', response)
  return response.data;
};

const postGenerate = async (data) => {
  const response = await axiosInstance.post(`/auth/generateCode`, data);
  return response.data;
}

const getCode = async (data) => {
  const response = await axiosInstance.post(`/auth/getCode`, data);
  return response.data;
}

const postAssesment = async (data) => {
  const response = await axiosInstance.post(`/assesment`, data);
  console.log('response getAssesment', response)
  return response.data;
};

const postAuth = async (data) => {
  const response = await axiosInstance.post(`/auth`, data);
  console.log('response postAuth', response)
  return response.data;
};

const postAuthLogin = async (data) => {
  const response = await axiosInstance.post(`/auth/login`, data);
  console.log('response postAuth', response)
  return response.data;
};

const getAuthEvent = async (data) => {
  const response = await axiosInstance.get(`/auth/event`, data);
  console.log('response getAuthEvent', response.data)
  return response.data;
};

const getAuthEvaluator = async (id, data) => {
  const response = await axiosInstance.get(`/auth/evaluator/${id}`, data);
  console.log('response getAuthEvaluator', response.data)
  return response.data;
};

const getEvent = async (event_id) => {
  const response = await axiosInstance.get(`/event/${event_id}`);
  console.log('response', response.data)
  return response.data;
};

const getEvaluator = async (evaluator_id) => {
  const response = await axiosInstance.get(`/event/evaluator/${evaluator_id}`);
  console.log('response', response.data)
  return response.data;
};

const getParticipantList = async (event_id, evaluator_id, group_id) => {
    
  const response = await axiosInstance.get(`/participant?event_id=${event_id}&evaluator_id=${evaluator_id}&group_id=${group_id}`);
  console.log('response', response)
  console.log('response getGroupList', response.data)
  return response.data;
};

const getGroupList = async (event_id, evaluator_id) => {
    
  const response = await axiosInstance.get(`/participant/groups?event_id=${event_id}&evaluator_id=${evaluator_id}`);
  console.log('response', response)
  console.log('response getGroupList', response.data)
  return response.data;
};

const api = {
    getEvent,
    getEvaluator,
    getAuthEvent,
    getAuthEvaluator,
    postAuth,
    postAuthLogin,
    getAssesment,
    postAssesment,
    getGroupList,
    getParticipantList,
    postGenerate,
    getCode
};

export default api;
